import React, { useState, useEffect, useRef, useMemo } from "react";
import InternetChecking from "../../Student/Reusablecomponents/Network";
import Loading from "../../Student/Reusablecomponents/Loading";
import { Row, Col } from "react-bootstrap";
import DropdownValues from "../../Student/Reusablecomponents/DropDownValues";
import Multiselect from "multiselect-react-dropdown";
import axiosInstance from "../../ReusableComponents/Axios";
import {
    GetAssessmentsNames,
    GetANamesInStitutes,
    Society,
    GetAssDateGrades,
} from "../../ReusableComponents/NCLAdminDropdowns";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import DiffGraph from "./DiffGraph";
import Lowiseperformance from "./LowisePerformance";
import PRCount from "./PRCount";
import SubjectWisePerformnace from "./SubjectWisePerformnace";
import notify from "../../ReusableComponents/ToastifyAlerts";
const PPTFilters = () => {
    const GradeRef = useRef();
    const [Load, SetLoad] = useState(false);
    const [SelectINID, SetSelectINID] = useState();
    const [SelecTest, SetSelecTest] = useState();
    const [SelectSubject, SetSelectSubject] = useState([]);
    const [SGrade, SetSGrade] = useState([]);
    const [RSOptions, SetRSOptions] = useState();
    const [SRSData, SetSRSData] = useState();
    const [ScoietyData, SetScoietyData] = useState();
    const [AssDates, SetAssDates] = useState();
    const [graphImage, setGraphImage] = useState(null);
    const [LographImage, setLOGraphImage] = useState(null);
    const [PieGraph, SetPieGraph] = useState(null);
    const [Piechartvalues, SetPiechartvalues] = useState();
    const [SWPGraph, SetSWPGraph] = useState(null);

    const HandleRSChange = (e) => {
        const selectedOption = RSOptions.find((opt) => opt.value === Number(e));
        if (selectedOption) {
            SetSRSData(selectedOption);
        }
    };
    const GradeOptions = (e) => {
        SetSGrade([e]);
        RenderSubjects([e]);
    };
    const RenderSubjects = async (SG) => {
        SetSelectSubject([]);
        // const Grade = JSON.parse(SG);
          const Grade = SG?.join(",");
        try {
            const res = await axiosInstance.get(`/NCLAdmin/GetResponceAssessmentSubjects?ContestcreationId=${AssDates?.value}&Grade=${Grade}&AssessmentTypeId=${AssDates?.assessmentType}`);
            const Foramtdata = res.data.map((Sub) => Sub.subjectName)
            console.log("Foramtdata", Foramtdata);
            SetSelectSubject(Foramtdata);
        }
        catch (err) { console.log(err) }
    };
    const GetRSDetails = async (INID, LType) => {
        try {
            const res = await axiosInstance.get(
                `/CommonAPI/GetRegionsOrStateslist?InstituteId=${INID}&ListType=${LType}`,
            );
            const RSDetails = res.data.map((item) => ({
                display: item.values,
                value: item.id,
            }));
            SetRSOptions([...RSDetails, { display: "All", value: 0 }]);
            SetSRSData(RSDetails[0]);
        } catch (err) {
            console.log(err);
        }
    };
    useEffect(() => {
        if (SelectINID?.value) {
            if (SelectINID?.value === 1 || SelectINID?.value === 3) {
                GetRSDetails(SelectINID?.value, "R");
            } else {
                GetRSDetails(SelectINID?.value, "S");
            }
        }
    }, [SelectINID?.value]);


    const EditPpt = async () => {

        const response = await fetch(SelectSubject?.length === 3 ? "/INSTPPT.pptx" : SelectSubject?.length === 4 ? "/INSTPPT4.pptx"
            : SelectSubject?.length === 5 && "/INSTPPT5.pptx");
        const blob = await response.blob();

        const zip = await JSZip.loadAsync(blob);

        const slidePath = "ppt/slides/slide1.xml";
        let slideXml = await zip.file(slidePath).async("string");

        const textMatches = [...slideXml.matchAll(/<a:t>(.*?)<\/a:t>/g)];
        const textArray = textMatches.map((m) => m[1]);


        if (textArray.length >= 4) {

            slideXml = slideXml.replace(
                `<a:t>${textArray[0]}</a:t>`,
                `<a:t>${SelecTest?.display.toUpperCase()}-${AssDates?.display} </a:t>`
                // `<a:t>             ${new Date().toLocaleDateString('en-GB')}</a:t>`
            );
            slideXml = slideXml.replace(
                `<a:t>${textArray[1]}</a:t>`,
                `<a:t>${SelectINID?.display}</a:t>`
            );
            slideXml = slideXml.replace(
                `<a:t>${textArray[2]}</a:t>`,
                `<a:t>""</a:t>`
            );
            slideXml = slideXml.replace(
                `<a:t>${textArray[4]}</a:t>`,
                `<a:t></a:t>`
                // `<a:t>${SelecTest?.display.toUpperCase()}</a:t>`
            );
        }

        zip.file(slidePath, slideXml);
        const slidePath13 = "ppt/slides/slide13.xml";
        let slideXml13 = await zip.file(slidePath13).async("string");

        const textMatches13 = [...slideXml13.matchAll(/<a:t>(.*?)<\/a:t>/g)];
        const textArray13 = textMatches13.map((m) => m[1]);
        if (textArray13.length >= 0) {

            slideXml13 = slideXml13.replace(
                `<a:t>${textArray13[0]}</a:t>`,
                `<a:t>${SelecTest?.display.toUpperCase()}</a:t>`
            );

        }
        zip.file(slidePath13, slideXml13);
        await replaceImageInSlide14(zip);
        await ReplaceLoWisePerformance(zip);
        await ReplaceImagePiechart(zip);
        await ReplaceSWP(zip);
        const updatedBlob = await zip.generateAsync({ type: "blob" });
        saveAs(updatedBlob, `${SelecTest?.display}_${SelectINID?.Code}_${SGrade}_${AssDates?.display}.pptx`);
        notify("PPT generated successfully for the selected assessment", "success");
        SetLoad(false);
    };

    const replaceImageInSlide14 = async (zip) => {
        const slideMap = {
            English: 17,
            Mathematics: 22,
            Science: 27,
            "Physics and Chemistry": 27,
            Hindi: 32,
            Telugu: 32,
            Biology: 32
        };

        const base64ToBlob = (base64) => {
            const base64Data = base64?.split(",")[1];
            const byteCharacters = atob(base64Data);
            const byteNumbers = Array.from(byteCharacters, (c) => c.charCodeAt(0));
            return new Blob([new Uint8Array(byteNumbers)], { type: "image/png" });
        };

        for (const [subject, slideNo] of Object.entries(slideMap)) {
            const graphImages = graphImage[subject];

            if (!graphImages) continue;

            const relPath = `ppt/slides/_rels/slide${slideNo}.xml.rels`;
            const relFile = zip.file(relPath);

            if (!relFile) {
                continue;
            }

            const relXml = await relFile.async("string");

            const imageMatch = relXml.match(/Target="..\/media\/(image\d+\.(png|jpg|jpeg))"/);

            if (!imageMatch) {
                continue;
            }

            const imageName = imageMatch[1];
            const mediaPath = `ppt/media/${imageName}`;

            zip.file(mediaPath, base64ToBlob(graphImages));

            const slidePath = `ppt/slides/slide${slideNo}.xml`;
            const slideFile = zip.file(slidePath);

            if (slideFile) {
                let slideXml = await slideFile.async("string");

                const textMatches = [...slideXml.matchAll(/<a:t>(.*?)<\/a:t>/g)];
                const textArray = textMatches.map((m) => m[1]);
                console.log("textArray", textArray);
                if (textArray.length > 0) {
                    slideXml = slideXml.replace(
                        `<a:t>${textArray[0]}</a:t>`,
                        `<a:t>${subject}- Difficulty-level mastery analysis</a:t>`
                    );
                }

                // Save the updated slide
                zip.file(slidePath, slideXml);
            }
        }
    };

    const ReplaceLoWisePerformance = async (zip) => {
        const slideMap = {
            English: 18,
            Mathematics: 23,
            Science: 28,
            "Physics and Chemistry": 28,
            Hindi: 33,
            Telugu: 33,
            Biology: 33
        };

        const base64ToBlob = (base64) => {
            const base64Data = base64?.split(",")[1];
            const byteCharacters = atob(base64Data);
            const byteNumbers = Array.from(byteCharacters, (c) => c.charCodeAt(0));
            return new Blob([new Uint8Array(byteNumbers)], { type: "image/png" });
        };

        for (const [subject, slideNo] of Object.entries(slideMap)) {
            const graphImages = LographImage[subject];

            if (!graphImages) continue;

            const relPath = `ppt/slides/_rels/slide${slideNo}.xml.rels`;
            const relFile = zip.file(relPath);

            if (!relFile) {
                continue;
            }

            const relXml = await relFile.async("string");

            const imageMatch = relXml.match(/Target="..\/media\/(image\d+\.(png|jpg|jpeg))"/);

            if (!imageMatch) {
                continue;
            }

            const imageName = imageMatch[1];
            const mediaPath = `ppt/media/${imageName}`;

            zip.file(mediaPath, base64ToBlob(graphImages));
            const slidePath = `ppt/slides/slide${slideNo}.xml`;
            const slideFile = zip.file(slidePath);

            if (slideFile) {
                let slideXml = await slideFile.async("string");

                const textMatches = [...slideXml.matchAll(/<a:t>(.*?)<\/a:t>/g)];
                const textArray = textMatches.map((m) => m[1]);
                console.log("textArray", textArray);
                if (textArray.length > 0) {
                    slideXml = slideXml.replace(
                        `<a:t>${textArray[0]}</a:t>`,
                        `<a:t>${subject} - Learning Gap Diagnosis by Concept</a:t>`
                    );
                }

                // Save the updated slide
                zip.file(slidePath, slideXml);
            }
        }
    }
    const ReplaceImagePiechart = async (zip) => {
        const relPath = "ppt/slides/_rels/slide14.xml.rels";
        const relXml = await zip.file(relPath).async("string");

        const imageMatch = relXml.match(/Target="..\/media\/(image\d+\.(png|jpg|jpeg))"/);

        const slidePath = "ppt/slides/slide14.xml";
        let slideXml = await zip.file(slidePath).async("string");
        const textMatches = [...slideXml.matchAll(/<a:t>(.*?)<\/a:t>/g)];
        const textArray = textMatches.map((m) => m[1]);
        if (textArray.length >= 4) {
            slideXml = slideXml.replace(
                `<a:t>${textArray[0]}</a:t>`,
                `<a:t> ${SelecTest?.display.toUpperCase()} - Participation Overview</a:t>`
            );
            slideXml = slideXml.replace(
                `<a:t>${textArray[1]}</a:t>`,
                `<a:t>Total Registered:${Piechartvalues?.[0]?.[`registered${SGrade}`]}</a:t>`
            );
            slideXml = slideXml.replace(
                `<a:t>${textArray[2]}</a:t>`,
                `<a:t> Grade ${SGrade}</a:t>`
            );
            slideXml = slideXml.replace(
                `<a:t>${textArray[3]}</a:t>`,
                `<a:t> ${SelectINID?.display}</a:t>`
            );
            slideXml = slideXml.replace(
                `<a:t>${textArray[4]}</a:t>`,
                `<a:t>Total Participated:${Piechartvalues?.[0]?.[`participated${SGrade}`]}</a:t>`
            );
            zip.file(slidePath, slideXml);
        }
        if (!imageMatch) {
            return;
        }

        const imageName = imageMatch[1];
        const mediaPath = `ppt/media/${imageName}`;

        const base64Data = PieGraph?.split(",")[1];
        const byteCharacters = atob(base64Data);

        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "image/png" });

        zip.file(mediaPath, blob);
    };
    const ReplaceSWP = async (zip) => {
        const relPath = "ppt/slides/_rels/slide15.xml.rels";
        const relXml = await zip.file(relPath).async("string");

        const imageMatch = relXml.match(/Target="..\/media\/(image\d+\.(png|jpg|jpeg))"/);

        const slidePath = "ppt/slides/slide15.xml";
        let slideXml = await zip.file(slidePath).async("string");
        const textMatches = [...slideXml.matchAll(/<a:t>(.*?)<\/a:t>/g)];
        const textArray = textMatches.map((m) => m[1]);

        const slidePath32 = SelectSubject?.length === 3 ? "ppt/slides/slide32.xml" : SelectSubject?.length === 4 ? "ppt/slides/slide34.xml"
            : SelectSubject?.length === 5 && "ppt/slides/slide36.xml";
        let slideXml32 = await zip.file(slidePath32).async("string");
        const textMatches32 = [...slideXml32.matchAll(/<a:t>(.*?)<\/a:t>/g)];
        const textArray32 = textMatches32.map((m) => m[1]);
        console.log("textArray32", textArray32);
        if (textArray.length >= 2) {
            slideXml = slideXml.replace(
                `<a:t>${textArray[0]}</a:t>`,
                `<a:t> ${SelecTest?.display.toUpperCase()} - Performance Overview</a:t>`
            );
            slideXml = slideXml.replace(
                `<a:t>${textArray[1]}</a:t>`,
                `<a:t>Grade ${SGrade}</a:t>`
            );
            slideXml = slideXml.replace(
                `<a:t>${textArray[2]}</a:t>`,
                `<a:t> ${SelectINID?.display}</a:t>`
            );
            slideXml32 = slideXml32.replace(
                `<a:t>${textArray32[0]}</a:t>`,
                `<a:t> ${SelectINID?.display} - Performance Comparison </a:t>`
            );
            // slideXml = slideXml.replace(
            //     `<a:t>${textArray[4]}</a:t>`,
            //     `<a:t>Total Participated:${Piechartvalues?.[0]?.[`participated${SGrade}`]}</a:t>`
            // );
            zip.file(slidePath, slideXml);
            zip.file(slidePath32, slideXml32);
        }

        if (!imageMatch) {
            return;
        }

        const imageName = imageMatch[1];
        const mediaPath = `ppt/media/${imageName}`;


        const base64Data = SWPGraph?.split(",")[1];
        const byteCharacters = atob(base64Data);

        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "image/png" });

        zip.file(mediaPath, blob);
    }

    useMemo(() => {
        if (AssDates?.grade) {
            const GG = AssDates?.grade.split(",").map((g) => g.trim())?.[0]
            SetSGrade([GG]);
            RenderSubjects([GG]);
        }
    }, [AssDates])
    // console.log("graphImage", graphImage);
    const HAndleEditPPT = () => {
        if (!graphImage) {
            notify("Difficulty level chart data is not available. Please check once.", "error");
            return;
        }

        if (!LographImage) {
            notify("LO chart data is not available. Please check once.", "error");
            return;
        }

        if (!PieGraph) {
            notify("Participation and performance chart data is not available. Please check once.", "error");
            return;
        }

        if (!SWPGraph) {
            notify("Subject wise performance chart data is not available. Please check once.", "error");
            return;
        }
        SetLoad(true);
        setTimeout(() => {
            EditPpt();
        }, 10000);
    }
    return (
        <>
            <div className="TeacherBgImage">
                <InternetChecking />
                <div className="MainHeading"> PPT Generation </div>

                <div className="container-fluid mt-4 InputFIlters">
                    <label>Input</label>
                    <br />
                    <Row>
                        <Col>
                            <GetAssessmentsNames className="NCLDropdown w-100" SOption={SelecTest?.value}
                                onChange={(e) => SetSelecTest(e)} StoreValue={SetSelecTest}
                                labelname={<div className="DropdownHeader">Assessment No :</div>} />
                        </Col>
                        <Col>
                            <GetANamesInStitutes className="NCLDropdown w-100" ATypeNO={SelecTest?.value}
                                StoreValue={SetSelectINID} SOption={SelectINID?.value} ClearValue={SetScoietyData}
                                labelname={<div className="DropdownHeader">Institute :</div>} />
                        </Col>
                        {SelectINID?.value && (
                            <Col>
                                <DropdownValues className="NCLDropdown w-100" options={RSOptions}
                                    selectoption={SRSData?.value} onChange={(e) => { HandleRSChange(e.target.value); }}
                                    labelname={
                                        <div className="DropdownHeader">
                                            {SelectINID?.value === 1 ||
                                                SelectINID?.value === 3 ||
                                                SelectINID?.value === 6
                                                ? "Region"
                                                : "State"}{" "}
                                            :
                                        </div>} />
                            </Col>
                        )}
                        {(SelectINID?.value === 8 ||
                            SelectINID?.value === 9 ||
                            SelectINID?.value === 5) && (
                                <Col>
                                    <Society className="NCLDropdown w-100"
                                        labelname={<div className="DropdownHeader">Society :</div>}
                                        PId={SelectINID?.value} SOption={ScoietyData?.value}
                                        StoreValue={SetScoietyData} onChange={(e) => { SetScoietyData(e); }} />
                                </Col>
                            )}

                        <Col>
                            <GetAssDateGrades className="NCLDropdown w-100" ATypeNO={SelecTest?.value}
                                InstID={SelectINID?.value} Scoiety={ScoietyData?.value}
                                SOption={AssDates?.value} StoreValue={SetAssDates}
                                labelname={<div className="DropdownHeader">Assessment Date :</div>} />
                        </Col>
                        <Col>
                            <div className="LabelName">
                                Grade :
                                <Multiselect ref={GradeRef} isObject={false} className="dropdown-checkbox mt-1 "
                                    selectedValues={SGrade} onRemove={(e, r) => GradeOptions(e, r)}
                                    style={{ color: "black" }}
                                    // style={(SelectSubject?.length <= 1 && Number(AssDates?.assessmentType) !== 3) ? { searchBox: { minHeight: "15vh", }, } : {}}
                                    onSearch={function noRefCheck() { }} placeholder="" singleSelect="true"
                                    // singleSelect={SelectSubject?.length > 1 || AssDates?.assessmentType === 3}
                                    avoidHighlightFirstOption="true"
                                    disablePreSelectedValues="true"
                                    onSelect={(e, r) => GradeOptions(e, r)}
                                    options={AssDates?.grade.split(",").map((g) => g.trim())}
                                    showCheckbox
                                />
                            </div>
                        </Col>
                        <Col>
                            <div className="LabelName">
                                Subject :
                                <ul className="subject-list" style={{
                                    border: "2px solid #cbcbcb",
                                    backgroundColor: "white", borderRadius: "5px",
                                    minHeight: "38px", padding: "5px 10px", listStyle: "none",
                                }} >
                                    {SelectSubject.map((sub) => (<li>{sub}</li>))}
                                </ul>
                            </div>
                        </Col> 

                    </Row>
                    <div className="dflex" style={{ justifyContent: "end" }}>
                        <button className={`Buttons m-3 ${Load && "DisableButton"}`} disabled={Load}
                            onClick={() => { !Load && HAndleEditPPT(); }} >
                            Generate PPT </button>
                    </div>
                </div>
                <DiffGraph SIND={SelectINID?.value} Grade={SGrade} CCAT={AssDates} GraphImg={setGraphImage} Subjects={SelectSubject} />
                <Lowiseperformance SIND={SelectINID?.value} Grade={SGrade} CCAT={AssDates} Subjects={SelectSubject} GraphImg={setLOGraphImage} />
                <PRCount SIND={SelectINID?.value} CCAT={AssDates} SOID={ScoietyData?.value} Grade={SGrade} GraphImg={SetPieGraph} PValues={SetPiechartvalues} />
                <SubjectWisePerformnace SIND={SelectINID?.value} CCAT={AssDates} SOID={ScoietyData?.value} RSIDs={SRSData?.value} Grade={SGrade} GraphImg={SetSWPGraph} />
            </div>
            {Load && <Loading />}
        </>
    )
}
export default PPTFilters;